import axios from "axios";

const useConfigurationProvider = () => {
  // Get configuration by key
  const getConfigurationProvider = (key) => {
    return axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}api/configuration/`,
      params: { key },
    });
  };

  // Create or update configuration
  const saveConfigurationProvider = (data) => {
    return axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}api/configuration/`,
      data,
    });
  };

  return {
    getConfigurationProvider,
    saveConfigurationProvider,
  };
};

export default useConfigurationProvider;
